import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "hubspot",
  "name": "HubSpot",
  "category": "integrations",
  "description": "Manage contacts, deals, and companies in HubSpot",
  "icon": "siHubspot",
  "iconType": "simple-icon",
  "color": "orange",
  "version": "2.1.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "HubSpot",
    "color": "#ff7a59"
  },
  "credentials": [
    {
      "name": "hubspotApi",
      "required": true,
      "displayName": "HubSpot API"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "hubspot",
    "crm",
    "sales",
    "marketing",
    "contacts"
  ],
  "comingSoon": true
};

export default definition;
